module.exports = __webpack_public_path__ + "static/media/激光切割手柄.59fe64be.png";